(() => {
  const body = document.body;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openers = document.querySelectorAll('[data-drawer-open]');
  const closers = document.querySelectorAll('[data-drawer-close]');

  const openDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    body.classList.add('is-locked');
    const first = drawer.querySelector('button, a, input');
    if (first) first.focus();
  };

  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    body.classList.remove('is-locked');
  };

  openers.forEach((button) => button.addEventListener('click', openDrawer));
  closers.forEach((button) => button.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.quantityChange || 0);
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(min, Number(input.value || min) + delta));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const submit = root.querySelector('[data-product-submit]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const dataNode = root.querySelector('[data-variant-json]');
    if (!select || !dataNode) return;

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      if (price) price.textContent = variant.price_formatted;
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
      if (compare) {
        compare.textContent = variant.compare_at_price_formatted || '';
        compare.hidden = !variant.compare_at_price_formatted;
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldText;
      }
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', newUrl.toString());
    });
  });

  document.querySelectorAll('[data-scroll-to-product-form]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-main-product-form]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const submit = target.querySelector('[data-product-submit]');
        if (submit) submit.focus({ preventScroll: true });
      }
    });
  });


  document.querySelectorAll('[data-product-gallery]').forEach((galleryRoot) => {
    const track = galleryRoot.querySelector('[data-product-gallery-track]');
    const items = track ? Array.from(track.querySelectorAll('.product-gallery__item')) : [];
    const dots = Array.from(galleryRoot.querySelectorAll('[data-gallery-dot]'));
    const prev = galleryRoot.querySelector('[data-gallery-prev]');
    const next = galleryRoot.querySelector('[data-gallery-next]');
    if (!track || items.length < 2) return;

    let activeIndex = 0;
    const setActive = (index, shouldScroll = false) => {
      activeIndex = Math.max(0, Math.min(items.length - 1, index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      if (shouldScroll) items[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => setActive(index, true)));
    if (prev) prev.addEventListener('click', () => setActive(activeIndex - 1, true));
    if (next) next.addEventListener('click', () => setActive(activeIndex + 1, true));

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const width = track.clientWidth || 1;
        const index = Math.round(track.scrollLeft / width);
        setActive(index, false);
        ticking = false;
      });
    }, { passive: true });
  });
})();
